import React, {
  createContext,
  FC,
  useContext,
  useEffect,
  useMemo,
} from 'react';
import { AuthContext, useApi } from '@repo-level/core-front';
import { pipe } from 'ramda';
import { useTranslation } from 'react-i18next';

import { slides as fetchSlides } from 'api/cms/slides';
import { Slide } from 'api/cms/slides';
import {
  filterByGroupAndDuration,
  filterBySchedule,
  sortByOrder,
} from 'helpers/cms';

interface LobbySliderContextData {
  lobbySlides?: Slide[];
  pending: boolean;
}

export const LobbySliderContext = createContext<LobbySliderContextData>(
  null as any
);

export const LobbySliderContextProvider: FC = ({ children }) => {
  const {
    i18n: { language },
  } = useTranslation('glossary');
  const { user } = useContext(AuthContext);

  const [requestFetchSlides, { data: slides, pending: pendingSlides }] = useApi(
    fetchSlides
  );

  const filteredSlides = useMemo(
    () =>
      slides
        ? pipe(
            filterByGroupAndDuration<Slide>({ user }),
            filterBySchedule,
            sortByOrder
          )(slides)
        : [],
    [slides, user]
  );

  useEffect(() => {
    requestFetchSlides(language);
  }, [requestFetchSlides, language]);

  return (
    <LobbySliderContext.Provider
      value={{ lobbySlides: filteredSlides, pending: pendingSlides }}
    >
      {children}
    </LobbySliderContext.Provider>
  );
};
